/* eslint-disable react/display-name */
import * as React from 'react';

interface IProps {
  style?: React.CSSProperties;
  className?: string;
}

export const createIcon =
  (children: React.ReactNode | string): React.FC<IProps> =>
  ({ style, className }: IProps) => {
    if (typeof children === 'string') {
      // eslint-disable-next-line react/no-danger
      return <span style={style} className={className} dangerouslySetInnerHTML={{ __html: children }} />;
    }

    return (
      <span style={style} className={className}>
        {children}
      </span>
    );
  };
